import { Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IFingerprint } from '@core/interfaces/fingerprint.Interface';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class FingerprintService {
  private readonly fingerprintCaptureUrl = environment.fingerprintCaptureUrl;

  constructor(private readonly http: HttpClient) {}

  private readonly signals = {
    quality: signal<number>(80),
    timeout: signal<number>(5000),
  };

  captureFingerprint(): Observable<IFingerprint | any> {
    return this.http.post(
      this.fingerprintCaptureUrl,
      {
        quality: this.signals.quality(),
        timeout: this.signals.timeout(),
      },
      {
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
        },
      }
    );
  }
  setTimeout(timeout: number): void {
    this.signals.timeout.set(timeout);
  }

  setQuality(quality: number): void {
    this.signals.quality.set(quality);
  }

  getTimeout(): number {
    return this.signals.timeout();
  }

  getQuality(): number {
    return this.signals.quality();
  }
}
